import { MEDICATIONS_ACTION_TYPES } from './actions';

// Initial state
const initialState = {
  drugStatus: 'active', // 'all', 'active', 'inactive' - default to active only
  selectedMedicationId: null,
  sortBy: 'newest', // 'alphabetic', 'newest', 'oldest' - default to newest first
  expandedSection: 'prescription', // 'prescription', 'prescribedRx', 'additional', null - default to prescription
  prescribedRxEnabled: false, // Enable/disable prescribedRx section toggle
};

// Reducer
const medicationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case MEDICATIONS_ACTION_TYPES.SET_DRUG_STATUS:
      return {
        ...state,
        drugStatus: action.payload,
      };

    case MEDICATIONS_ACTION_TYPES.SET_SELECTED_MEDICATION_ID:
      return {
        ...state,
        selectedMedicationId: action.payload,
      };

    case MEDICATIONS_ACTION_TYPES.SET_SORT_BY:
      return {
        ...state,
        sortBy: action.payload,
      };

    case MEDICATIONS_ACTION_TYPES.SET_EXPANDED_SECTION:
      return {
        ...state,
        expandedSection: action.payload,
      };

    case MEDICATIONS_ACTION_TYPES.SET_PRESCRIBED_RX_ENABLED:
      return {
        ...state,
        prescribedRxEnabled: action.payload,
      };

    case MEDICATIONS_ACTION_TYPES.RESET_MEDICATIONS_FILTERS:
      return initialState;
      
    case MEDICATIONS_ACTION_TYPES.SET_DEFAULT_MEDICATIONS_FILTERS:
      return {
        ...state,
        drugStatus: 'active',
        sortBy: 'newest',
        expandedSection: 'prescription',
        prescribedRxEnabled: false,
        selectedMedicationId: null,
      };

    default:
      return state;
  }
};

export default medicationsReducer;
